
<v-card
    class   = "v-flex w-100"
    :class  = "selected || mapSelected ? 'inspection-selected' : ''"
    :ripple = "false"
    @click  = "onSelected"
    flat
    rounded
>
    <!-- Order color slice -->
    <div
        v-if   = "!location.orderList || location.orderList.length === 0"
        class  = "order-color"
        :style = "orderColor"
    >
    </div>

    <div
        v-for="(ord,index) in location.orderList"
        :key = "index"
        :style = "color (ord)"
    >
    </div>
    <!-- Order color slice -->

    <!-- Order details -->
    <p-disposition-order-details
        v-if  = "showOrder"
        :unit = "location"
    />
    <!-- Order details -->

    <!-- Location header -->
    <div
        v-if   = "location.header"
        :class = "locationHeaderStyle"
        class  = "unit-header unit-header-divider"
    >
        <p-disposition-location
            :location     = "location"
            :dispatch-on  = "dispatchOn"
            :assign-on    = "assignOn"
            :user         = "user"
            :refresh      = "refresh"
            @expand       = "onExpand"
            @collapse     = "onCollapse"
            @dispatch-all = "onDispatchAll"
            @release-all  = "onReleaseAll"
            @assign-all   = "onAssignAll"
            @dissolve-all = "onDissolveAll"
            @locate       = "onLocate"
        />
    </div>
    <!-- Location header -->

    <!-- unit details -->
    <div
        v-if   = "!location.header"
        class  = "ml-0"
        :class = "showOrder ? 'w-50' : 'w-100'"
    >
        <p-disposition-unit-details
            :order       = "order"
            :unit        = "location"
            :assignment  = "assignment"
            :dispatch-on = "dispatchOn"
            :assign-on   = "assignOn"
            :user        = "user"
            @assign      = "onAssign"
            @dissolve    = "onDissolve"
            @dispatch    = "onDispatch"
            @release     = "onRelease"
            @edit        = "onEditUnit"
        />
    </div>
    <!-- unit details -->
</v-card>
